import { type ComponentProps, type ReactNode } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { Heading, IconButton } from '@launchpad-ui/components';

import styles from './Dialog.module.css';

type Props = ComponentProps<typeof Heading> & {
  onClose?: (() => void) | undefined;
  children: ReactNode;
};

export function DialogHeading(props: Props) {
  return (
    <div className={styles.heading}>
      <Heading slot="title">{props.children}</Heading>
      {props.onClose && (
        <IconButton
          aria-label={msg('ui.dialog.closeLabel')}
          variant="minimal"
          icon="cancel"
          size="small"
          onPress={props.onClose}
        />
      )}
    </div>
  );
}
